import { User } from '../models/user';

export class AddUserPermissionsSuccess {
    static readonly type = '[User] AddUserPermissionsSuccess';

    constructor(public payload: User[]) {}
}
